import React, { useState, useEffect } from 'react';
import { Link, useLocation, matchPath } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Transition } from 'react-transition-group';
import Scrollspy from 'react-scrollspy';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import AddressButton from '../../AddressButton/DesktopView';
import AuthModule from '../../AuthModule';
import LangSwitcher from '../../LangSwitcher';
import Nav from '../../Nav';
import Container from '../../Container';
import CategoryNavItem from '../../CategoryNavItem';

// Icons
import CrossIcon from '../../../icons/cross.svg';
import { getHeaderLogoSrc } from '../headerLogo';
import { CITY_THEME_DISNEY, CITY_THEME_MOTHERS_DAY, isThemeActive, isVisualThemeActive } from '../../../utils/cityTheme';

// Router
import { getRoute } from '../../../entry/routes';

// Config
import config from '../../../config';

// Styles
import styles from './DesktopView.styl';

const cx = classNames.bind(styles);

export { logos } from '../headerLogo';

export default function DesktopView(props) {
  const { className } = props;

  const location = useLocation();
  const categories = useSelector(state => state.catalog.products.categories);
  const isHomeCategoriesStick = useSelector(state => state.ui.isHomeCategoriesStick);
  const locale = useSelector(state => state.intl.locale);
  const userCity = useSelector(state => state.city.userCity);
  const { isOpen } = useSelector(state => state.popup.list?.auth) || {};

  const [isMainNavOpen, setIsMainNavOpen] = useState(true);
  const [isStickyNavOpen, setIsStickyNavOpen] = useState(false);

  const lang = config.legal === 'kz' || config.legal === 'kg' ? 'en' : locale;
  const logoSrc = getHeaderLogoSrc(lang, userCity);
  const isDisneyTheme = isVisualThemeActive(userCity, CITY_THEME_DISNEY);
  const isMothersDayTheme = isThemeActive(userCity, CITY_THEME_MOTHERS_DAY);
  const isHome = matchPath(location.pathname, { path: getRoute('home'), exact: true });

  const handleOnMainNavToggle = () => {
    setIsMainNavOpen(prev => !prev);
  };

  const handleOnStickyNavToggle = () => {
    setIsStickyNavOpen(prev => !prev);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    if (isOpen) {
      setIsMainNavOpen(true);
    }
  }, [isOpen]);

  return (
    <>
      <header className={cx('Header', className, { Header_home: isHome })} id="Header">
        <Container className={cx('Header__container')}>
          <Link
            className={cx('Header__logo', {
              Header__logo_disney: isDisneyTheme,
              Header__logo_mothersDay: isMothersDayTheme,
            })}
            to={getRoute('home')}
          >
            <img src={logoSrc} alt="Papa John's" />
          </Link>
          {isMainNavOpen ? (
            <>
              <AddressButton />
              <Nav className={cx('Header__nav')} />
              <AuthModule />
            </>
          ) : (
            <AddressButton />
          )}
          <LangSwitcher />
          {/*<button onClick={handleOnMainNavToggle} className={cx('Header__hamburger')} type="button">*/}
          {/*  {isMainNavOpen ? (*/}
          {/*    <CrossIcon />*/}
          {/*  ) : (*/}
          {/*    <>*/}
          {/*      <span className={cx('Header__hamburger-line')} />*/}
          {/*      <span className={cx('Header__hamburger-line')} />*/}
          {/*      <span className={cx('Header__hamburger-line')} />*/}
          {/*    </>*/}
          {/*  )}*/}
          {/*</button>*/}
        </Container>
      </header>
      <Transition
        in={isHome && isHomeCategoriesStick}
        timeout={{ enter: 0, exit: 350 }}
        mountOnEnter
        unmountOnExit
      >
        {state => (
          <header
            className={cx('Header__sticky', `Header__sticky_${state}`, className)}
            id="Header_sticky"
          >
            <Container className={cx('Header__container')}>
              <button
                className={cx('Header__logo', {
                  Header__logo_disney: isDisneyTheme,
                  Header__logo_mothersDay: isMothersDayTheme,
                })}
                onKeyPress={e => e.key === 'Enter' && scrollToTop()}
                type="button"
                onClick={scrollToTop}
              >
                <img src={logoSrc} alt="Papa John's" />
              </button>
              {isStickyNavOpen ? (
                <>
                  <Nav className={cx('Header__nav')} />
                  <AuthModule />
                </>
              ) : (
                <Scrollspy
                  className={cx('Header__categories')}
                  items={categories.map(category => category.alias)}
                  currentClassName={cx('Header__category_active')}
                  offset={-50}
                  componentTag="div"
                >
                  {categories.map(c => (
                    <CategoryNavItem
                      key={c.alias}
                      className={cx('Header__category')}
                      tabIndex="0"
                      alias={c.alias}
                      role="menuitem"
                    >
                      {c.name}
                    </CategoryNavItem>
                  ))}
                </Scrollspy>
              )}
              <LangSwitcher />
              <button
                onClick={handleOnStickyNavToggle}
                className={cx('Header__hamburger')}
                type="button"
              >
                {isStickyNavOpen ? (
                  <CrossIcon />
                ) : (
                  <>
                    <span className={cx('Header__hamburger-line')} />
                    <span className={cx('Header__hamburger-line')} />
                    <span className={cx('Header__hamburger-line')} />
                  </>
                )}
              </button>
            </Container>
          </header>
        )}
      </Transition>
    </>
  );
}

DesktopView.defaultProps = {
  className: '',
};

DesktopView.propTypes = {
  className: PropTypes.string,
};
